
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.124 7.876a1.688 1.688 0 100-3.376 1.688 1.688 0 000 3.376zm2.071-.726a.75.75 0 00-.706.496l-1.692 4.717a.748.748 0 00.017.55l-4.156 2.39a.752.752 0 00-.156.118L6.034 13.1a.75.75 0 00-1.223-.063l-4 5.085a.75.75 0 00.589 1.213h7.216a.75.75 0 00.633-1.15l-.964-1.525a.757.757 0 00.12-.056l4.66-2.679a.75.75 0 00.18-1.155L14.5 9.267l1.783 1.783-2.62 2.62a.75.75 0 00-.219.53v3.24a.75.75 0 001.5 0v-2.93l1.65-1.65v1.34c0 .199.08.39.22.53l3.24 3.24a.75.75 0 001.06-1.06l-3.02-3.02v-2.84a.75.75 0 00-.22-.53l-1.87-1.87h2.74l.176.177-.525.302a.75.75 0 00.747 1.3l3.13-1.8a.75.75 0 10-.747-1.3l-1.258.723-.683-.683a.75.75 0 00-.53-.22h-4.86zM2.945 17.834h4.309l-1.92-3.036-2.39 3.036z"}})])
          )
        }
      }
    